import {
  Field as IField,
  RowFieldGroup as IRowFieldGroup,
} from "@/core/types/types";

/**
 * Manages the grouping of fields by their row property.
 *
 * This function iterates over fields and groups them based on the `row` property
 * defined in their layout. Fields with the same `row` value are grouped together.
 * If a field does not have a `row` property, it is treated as its own group.
 *
 * @param {IRowFieldGroup[]} acc - The accumulator that holds the grouped fields.
 * @param {IField} currentField - The current field being processed.
 * @returns {IRowFieldGroup[]} The updated accumulator with the current field grouped appropriately.
 */
const rowGroupManager = (
  acc: IRowFieldGroup[],
  currentField: IField
): IRowFieldGroup[] => {
  const row: string | undefined = currentField.layout?.row;
  if (!row) {
    acc.push([currentField]);
    return acc;
  }

  const existingGroup: IRowFieldGroup | undefined = acc.find(
    (item) => item[0]?.layout?.row === row
  );
  if (existingGroup) {
    existingGroup.push(currentField);
  } else {
    acc.push([currentField]);
  }

  return acc;
};

export default rowGroupManager;
